/**
 * @description Genera el texto para imprimir según la cantidad de años, meses y días ingresados,
 *
 * @author ana.carrasco  Hábil MX
 * @version 1.0.0, 15/05/2023
 * @param cantidadAnios
 * @param cantidadMeses
 * @param cantidadDias
 * @returns matriz[0] string con mensaje en años, meses y días.
 *          Matriz[1-3] string con mensaje años, meses, días(según el índice)
 */
export const generarTextoAnioMesDia = (
  cantidadAnios: number,
  cantidadMeses: number,
  cantidadDias: number
) => {
  const mensaje = ['']

  cantidadAnios > 1
    ? mensaje.push(cantidadAnios + ' años ')
    : cantidadAnios === 1 && mensaje.push(cantidadAnios + ' año ')

  cantidadMeses > 1
    ? mensaje.push(cantidadMeses + ' meses ')
    : cantidadMeses === 1 && mensaje.push(cantidadMeses + ' mes ')

  cantidadDias > 1
    ? mensaje.push(cantidadDias + ' días ')
    : cantidadDias === 1 && mensaje.push(cantidadDias + ' día ')

  const mensajeAnios = ['']
  const mensajeMeses = ['']
  const mensajeDias = ['']
  cantidadAnios > 1
    ? mensajeAnios.push(cantidadAnios + ' años ')
    : cantidadAnios === 1 && mensajeAnios.push(cantidadAnios + ' año')
  cantidadMeses > 1
    ? mensajeMeses.push(cantidadMeses + ' meses ')
    : cantidadMeses === 1 && mensajeMeses.push(cantidadMeses + ' mes')
  cantidadDias > 1
    ? mensajeDias.push(cantidadDias + ' días ')
    : cantidadDias === 1 && mensajeDias.push(cantidadDias + ' día')
  return [mensaje, mensajeAnios, mensajeMeses, mensajeDias]
}
